import type { InterestType, Month } from '@/app/lcv/types/calculator';

export const MODEL_CATEGORY = {
  PUP_V_CROSS: 'v-cross',
  PUP_4_DOOR: '4-door',
  PUP_2_DOOR: '2-door',
  PUP_SPARK: 'spark',
  PUP_X_SERIES: 'x-series',
  PPV_MU_X: 'mu-x',
} as const;

export type ModelCategory =
  (typeof MODEL_CATEGORY)[keyof typeof MODEL_CATEGORY];

export const DEFAULT_SELECT_MODEL_CATEGORY = MODEL_CATEGORY.PUP_V_CROSS;

export const QUERY_MODEL_CATEGORY = {
  [MODEL_CATEGORY.PUP_V_CROSS]: MODEL_CATEGORY.PUP_V_CROSS,
  [MODEL_CATEGORY.PUP_4_DOOR]: MODEL_CATEGORY.PUP_4_DOOR,
  [MODEL_CATEGORY.PUP_2_DOOR]: MODEL_CATEGORY.PUP_2_DOOR,
  [MODEL_CATEGORY.PUP_SPARK]: MODEL_CATEGORY.PUP_SPARK,
  [MODEL_CATEGORY.PUP_X_SERIES]: MODEL_CATEGORY.PUP_X_SERIES,
  [MODEL_CATEGORY.PPV_MU_X]: MODEL_CATEGORY.PPV_MU_X,
} as const;

export const NO_EURO_4_SUFFIX_MODELS = ['มิว-เอ็กซ์'];

export const INTEREST_TYPE_TIL = 'อีซูซุลิสซิ่ง';
export const SELF_INPUT = 'กรอกเอง';
export const MIN_PERCENT = '5';
export const MAX_PERCENT = 100;
export const TIL_DEFAULT_PERCENT = 20;

export const REGISTER_DATA_TITLE = 'ลงทะเบียนสนใจรถ';
export const MONTH_OPTIONS: Month[] = [
  {
    label: '48',
    value: '48',
  },
  {
    label: '60',
    value: '60',
  },
  {
    label: '72',
    value: '72',
  },
  {
    label: '84',
    value: '84',
  },
];
export const DEFAULT_MONTH_OPTION: Month = {
  label: '84',
  value: '84',
};

export const INTEREST_OPTIONS: InterestType[] = [
  { label: INTEREST_TYPE_TIL, value: INTEREST_TYPE_TIL },
  { label: SELF_INPUT, value: SELF_INPUT },
];

export const MAX_INTEREST = 5;

export const EURO_4_SUFFIX = '(EURO 4)';

export const ORDER_NAME = [
  `วี-ครอส 4x4 ${EURO_4_SUFFIX}`,
  `วี-ครอส 4x4`,
  `ปิกอัพ 4 ประตู ${EURO_4_SUFFIX}`,
  `ปิกอัพ 4 ประตู`,
  `ปิกอัพ 2 ประตู ${EURO_4_SUFFIX}`,
  `ปิกอัพ 2 ประตู`,
  `สปาร์ค ${EURO_4_SUFFIX}`,
  `สปาร์ค`,
  `เอ็กซ์-ซีรี่ส์ ${EURO_4_SUFFIX}`,
  `เอ็กซ์-ซีรี่ส์`,
  `มิว-เอ็กซ์`,
];
